module.exports = __webpack_public_path__ + "img/1920_nav_img1.09ab1118.png";